import React from "react";
import { Link } from "react-router-dom";

import { WhatsAppLogo } from "./WhatsAppLogo";
import { ContentList } from "../elements";

export const SmartphoneHeader = ({ notice }) => (
  <header className="smartphone">
    <div className="carousel">
      <div className="overlay">
        <a className="logo" href="/">
          <img
            src="/assets/images/logo.png"
            alt="Logo Youcan Fitness Factory"
          />
        </a>
      </div>
      <ContentList>
        <img src="/assets/images/slideshow/youcan-5.jpg" alt="" />
        <img src="/assets/images/slideshow/youcan-7.jpg" alt="" />
        <img src="/assets/images/slideshow/youcan-4.jpg" alt="" />
        <img src="/assets/images/slideshow/youcan-8.jpg" alt="" />
        <img src="/assets/images/slideshow/youcan-3.jpg" alt="" />
        <img src="/assets/images/slideshow/youcan-6.jpg" alt="" />
        <img src="/assets/images/slideshow/youcan-1.jpg" alt="" />
      </ContentList>
    </div>

    <div className="content">
      <h1>
        Il centro fitness
        <br />
        di Milano Bovisa
      </h1>
      <p>
        <WhatsAppLogo /> <a href="https://wa.me/393534724004">353.472.4004</a>
        <br />
        <Link to="/contatti">info@youcanfitnessfactory.it</Link>
        <br />
        Via Ugoni 15, Milano
      </p>
      <hr />
      <h2>Orari</h2>
      <div className="uk-grid uk-grid-small uk-flex-center">
        <div className="uk-width-auto">
          <p className="uk-text-right">
            Lun-Ven:
            <br />
            Sab:
            <br />
            Dom:
          </p>
        </div>
        <div className="uk-width-auto">
          <p>
            07:30 - 23:00
            <br />
            09:30 - 19:00
            <br />
            09:30 - 14:00
          </p>
        </div>
      </div>
    </div>

    <div className="mini-news">
      {notice && (
        <div className="wrapper">
          <span className="title">News</span>
          <div dangerouslySetInnerHTML={{ __html: notice.join("<br />") }} />
        </div>
      )}
    </div>
  </header>
);



// WEBPACK FOOTER //
// ./src/ui/components/SmartphoneHeader.js